// import * as Yup from "yup";

// const phoneRegExp =
//   /^((\\+[1-9]{1,4}[ \\-])|(\\([0-9]{2,3}\\)[ \\-])|([0-9]{2,4})[ \\-])?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// const mobileRegExp = /^[0-9]{10}$/;
// const nameRegExp = /^[A-Za-z\s'-]+$/;

// const addressRegExp = /^[A-Za-z0-9\s.,'-]+$/;

// const countryRegExp = /^(United States|Canada|United Kingdom|Australia)$/i;

// export const signinEmailSchema = Yup.object({
//   name: Yup.string()
//     .required("First Name is required")
//     .matches(nameRegExp, "Invalid First Name"),
//   email: Yup.string()
//     .required("Email is Required")
//     .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Enter Valid Email"),
//   password: Yup.string().required("Password is required"),
// });

// export const signinSchema = Yup.object({
//   mobile: Yup.string()
//     .required("Mobile Number is Required")
//     .matches(/^[0-9]{10}$/, "Enter a 10-digit mobile number"),
//   address: Yup.string()
//     .required("Address is Required")
//     .matches(addressRegExp, "Invalid Address"),
//   country: Yup.string()
//     .required("Country Residence is Required")
//     .matches(countryRegExp, "Invalid Country Residence"),
// });

import * as Yup from "yup";

// Define validation schema using Yup
export const validationSchema = Yup.object({
  userId: Yup.string().required("User ID is required").matches(/^\S*$/, 'User ID should not contain spaces'),
  password: Yup.string().required("Password is required"),
  dateOfBirth: Yup.string().required("Date of Birth is required"),
  // pan: Yup.string()
  //   .matches(/^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/, "Invalid PAN format")
  //   .required("PAN is required"),
});
